import { lazyNamed } from "src/utils/lazy-named";
import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";
import { dashboardLoader } from "./loader";
import { PollingContextProvider } from "./polling/provider";

const Dashboard = lazyNamed(() => import("./dashboard"), "Dashboard");
const dashboardsImport = () => import("./dashboards");
const Dashboards = lazyNamed(dashboardsImport, "Dashboards");

export const preloads: RoutePreload[] = [["/dashboards", dashboardsImport]];
const NewDashboardModal = lazyNamed(
  () => import("./new-dashboard"),
  "NewDashboardModal",
);

export const routes: RouteObject[] = [
  {
    path: "dashboards",
    spacesAccess: "hidden-from-limited-view",
    element: <Dashboards />,
    children: [
      {
        path: "new",
        spacesAccess: "hidden-from-limited-view",
        element: <NewDashboardModal isOpen />,
      },
    ],
  },
  {
    path: "dashboards/:dashboardId",
    spacesAccess: "hidden-from-limited-view",
    element: (
      <PollingContextProvider>
        <Dashboard />
      </PollingContextProvider>
    ),
    loader: dashboardLoader,
  },
  {
    path: "dashboards/:dashboardId/edit",
    spacesAccess: "hidden-from-limited-view",
    element: (
      <PollingContextProvider>
        <Dashboard isEditMode />
      </PollingContextProvider>
    ),
    loader: dashboardLoader,
  },
];
